import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "hi", "zh"],
  defaultLocale: "en",
  localePrefix: "always",
});
